import cloneDeep from 'lodash/cloneDeep';
import Conversation from '@/classes/v2/Conversation';

const allConversations = state => {
  return cloneDeep(state.conversations).sort(Conversation.compare) || [];
};

const activeConversation = state => {
  const conversation = state.conversations.find(conversation => conversation.conversationId === state.activeConversationId);
  return conversation ? cloneDeep(conversation) : null;
};

const activeConversationId = state => {
  return state.activeConversationId;
};

const getConversationById = state => conversationId => {
  const conversation = state.conversations.find(conversation => conversation.conversationId === conversationId);
  return conversation ? cloneDeep(conversation) : null;
};

const getUnreadConversations = state => {
  return cloneDeep(state.conversations.filter(conversation => conversation.unreadMessages));
};

const getConversationsContainingMessageTextOrContactName = state => messageText => {
  return cloneDeep(state.conversations.filter(convo => convo.messages.some(msg => msg.includes(messageText)) ||
    convo.contact.fullName.toLowerCase().includes(messageText.toLowerCase())));
}

const tmpMessages = state => {
  return cloneDeep(state.tmpMessages);
}

export default {
  tmpMessages,
  activeConversation,
  activeConversationId,
  allConversations,
  getConversationById,
  getConversationsContainingMessageTextOrContactName,
  getUnreadConversations
};
